import bannerIndex from '../../pages/banner'

const BannerRoute = [
  {
    path: '/banner',
    name: 'banner',
    component: bannerIndex
  }
]
export default BannerRoute



// WEBPACK FOOTER //
// ./src/router/banner/index.js